import { Text, Box, Heading } from '@chakra-ui/react';
import { ReasonsFlexBox } from './ReferralReasonsContent/ReasonsFlexBox';
import { styleFontColor as style } from './ReferralReasonsContent/utils';

export const ReferralReasons = () => (
  <Box mb={16}>
    <Heading mb={5} fontSize="2xl">
      Precisa de motivos para recomendar a Inventa?
    </Heading>

    <Text pb={4} color={style.txLightweightBlack}>
      Conquistar novos lojistas, garantir 0% de comissão e oferecer R$250 de
      desconto para o seu cliente não é o suficiente? Com a indicação de
      clientes você tem ainda mais vantagens! Separamos 3 motivos incríveis para
      indicar seus lojistas para comprar de você pela Inventa que vão te fazer
      indicar lojistas agora mesmo.
    </Text>
    <ReasonsFlexBox />
  </Box>
);
